






























import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { requiredString } from "@/tool/validation";
import { VForm } from "@/common/vuetify_types";
import { Company } from "@/api";

@Component
export default class EditPopUpTextArea extends Vue {
  @Ref("form") form!: VForm;
  @Prop() value!: string;
  @Prop() label!: string;
  @Prop() title!: string;
  @Prop() loading!: boolean;
  @Prop() company!: Company;
  requiredTextInput = [requiredString];
  editValue = JSON.parse(JSON.stringify(this.value || ""));

  close() {
    this.$emit("close");
  }

  save() {
    if (this.form.validate()) {
      const updateCompany = JSON.parse(JSON.stringify(this.company)) as Company;
      switch (this.title) {
        case "Vision":
          updateCompany.vision = this.editValue;
          break;
        case "Mission":
          updateCompany.mission = this.editValue;
          break;
        case "Core Values":
          updateCompany.coreValues = this.editValue;
          break;
        default:
          break;
      }
      this.$emit("save", updateCompany);
    }
  }
}
